/**
 * Hero Carousel Configuration
 * Constants and options for the hero carousel management
 */

const carouselConfig = {
  // Number of slides (fixed)
  slideCount: 3,

  // Default page for carousel
  defaultPage: 'home',

  // Available button styles for slides
  // These match the CSS classes used on the ecommerce frontend
  buttonStyles: [
    {
      value: 'white-btn',
      label: 'White Button',
      description: 'Solid white background with dark text',
    },
    {
      value: 'white-trans-btn-with-white-border',
      label: 'Transparent White',
      description: 'Transparent background with white border',
    },
  ],

  // Validation rules (matching backend API)
  validation: {
    title: {
      required: true,
      maxLength: 255,
    },
    subtitle: {
      required: false,
      maxLength: 500,
    },
    buttonText: {
      required: false,
      maxLength: 100,
    },
    buttonLink: {
      required: false,
      maxLength: 255,
    },
    buttonStyle: {
      required: false,
    },
    imageUrl: {
      required: true,
    },
    readMoreContent: {
      required: false,
      maxLength: 500,
    },
  },

  // Image preview settings
  imagePreview: {
    aspectRatio: '16:9',
    minHeight: 200,
  },

  // Recommended image size for hero slides
  recommendedImageSize: {
    width: 1920,
    height: 1080,
  },
};

// Helper to get button style by value
export const getButtonStyleLabel = (value) => {
  const style = carouselConfig.buttonStyles.find((s) => s.value === value);
  return style ? style.label : value;
};

// Helper to check if a button style is valid
export const isValidButtonStyle = (value) => {
  if (!value) return true; // Optional field
  return carouselConfig.buttonStyles.some((s) => s.value === value);
};

export default carouselConfig;
